<template>
    <b-modal
        v-model="openLookupModal"
        title="Nueva Invitación"
        header-bg-variant="dark"
        header-text-variant="light"
        size="md"
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
    >
        <b-form-group label="NIT de la empresa">
            <b-input-group>
                <b-form-input 
                    v-model="lookupData.nit" 
                    placeholder="Ej: 800151127"
                    :disabled="lookupData.loading"
                    @keyup.enter="$emit('confirm-lookup')"
                />
            </b-input-group>
        </b-form-group>

        <b-alert variant="danger" :show="!!lookupData.error">
            {{ lookupData.error }}
        </b-alert>

        <template v-slot:modal-footer>
            <b-button variant="danger" @click.prevent="$emit('close-modal')">
                Cancelar
            </b-button>
            <b-button 
                variant="success" 
                :disabled="!lookupData.nit || lookupData.loading"
                @click.prevent="$emit('confirm-lookup')"
            >
                <b-spinner small v-if="lookupData.loading" />
                <span v-else>Buscar</span>
            </b-button>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: 'ModalLookupInvitation',
    props: {
        openLookupModal: {
            type: Boolean,
            default: false
        },
        lookupData: {
            type: Object
        }
    }
}
</script>